import React, { forwardRef, ReactNode } from 'react';
import styles from './Badge.module.css';

export interface BadgeProps {
    children: ReactNode;
    variant?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'outline' | 'ghost';
    size?: 'small' | 'medium' | 'large';
    icon?: ReactNode;
    className?: string;
}

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(({
    children,
    variant = 'default',
    size = 'medium',
    icon,
    className = ''
}, ref) => {
    const badgeClasses = [
        styles.badge,
        styles[variant],
        styles[size],
        className
    ].filter(Boolean).join(' ');

    return (
        <span className={badgeClasses} ref={ref}>
            {icon && <span className={styles.icon}>{icon}</span>}
            {children}
        </span>
    );
});

Badge.displayName = 'Badge';

export default Badge;
